import React, { FC, memo } from "react";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { CardSection } from "@/components/Section";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, TStyleDirection } from "@/eworkitComponents";

interface Props {
  title: string;
  margin?: TStyleDirection;
}

export const Widget: FC<Props> = memo(({ children, title, margin }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <CardSection padding={isSmallScreen ? ["md"] : ["lg"]} margin={margin}>
      <Flex margin={[false, false, "md", false]}>
        <Header weight="bold" size="sm">
          {title}
        </Header>
      </Flex>
      <Flex direction="column">{children}</Flex>
    </CardSection>
  );
});
